import React from "react";
import MiniDrawer from "../../components/Drawer"
import ClientsGrid from "../../components/Clients"

const Clients = (socket) => {
    return (
        <MiniDrawer child={<ClientsGrid />} socket={socket.socket} />
    );
};

export default Clients;